var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#515c6f}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9124",
    transform: "translate(-17 -36)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2555",
    width: 17,
    height: 2,
    className: "cls-1",
    rx: 1,
    transform: "translate(17 43)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2557",
    width: 20,
    height: 2,
    className: "cls-1",
    rx: 1,
    transform: "translate(17 50)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2556",
    width: 20,
    height: 2,
    className: "cls-1",
    rx: 1,
    transform: "translate(17 36)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.8544136619cce1e3cfbbc0b0b55fce48.svg";
export { ForwardRef as ReactComponent };